import { Constant } from "../../config";
import { Tag } from "antd";
import React from "react";
import axios from "axios";

const LIST_LIMIT = 20;

export const MAPKEY_FORM_VALUE = {
  [Constant.TABLE_SMS_LOGS.API]: {
    sender: "e",
    country: "p",
    smid: "o",
    gateway: "i",
    gateway_smid: "f",
    status: "g",
  },
  [Constant.TABLE_SMS_LOGS.CAMPAIGN]: {
    sender: "e",
    country: "o",
    smid: "n",
    gateway: "i",
    gateway_smid: "f",
    status: "g",
  },
  [Constant.TABLE_SMS_LOGS.SMPP]: {
    sender: "e",
    country: "n",
    smid: "m",
    gateway: "i",
    gateway_smid: "f",
    status: "g",
  },
  [Constant.TABLE_SMS_LOGS.VIBER_CAM]: {
    sender: "d",
    country: "m",
    smid: "l",
    gateway: "h",
    gateway_smid: "e",
    status: "f",
  },
};

export const DATA_QUERY = {
  page: 1,
  limit: LIST_LIMIT,
  start_date: "",
  end_date: "",
  b: true,

  // // search opts
  // a: 0, //member_id
  // b: false, //send-date
  // c: "", //msisdn
  // e: "", //sender
  // f: "", //gateway-smid
  // g: "", //status
  // h: 0, //gateway-dr-status-id
  // i: 0, //gateway-id
  // j: 0, //api-key-id
  // k: "", //callback-method
  // l: "", //callback-url
  // m: false, //ackdate
  // o: "", //smid
  // p: "", //country
  // q: false,
  // r: false, //notify-date
  // v: false,
};

export async function getRawLogs(queries) {
  if (Object.keys(queries).length === 0) {
    return [];
  }

  let query = "";
  for (const key of Object.keys(queries)) {
    if (key === "collection") {
      const repl = queries[key].replace("-", "_");
      queries[key] = repl;
      continue;
    }

    query += `${key}=${queries[key]}&`;
  }

  const opt = {
    url: `${Constant.SL_RAW(
      queries["collection"]
    )}?${query}order=desc&order_by=b`,
    method: "GET",
    headers: {
      Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
    },
  };

  let resp;

  try {
    resp = await axios(opt);
  } catch (err) {
    resp = err.response;
  }

  if (!!!resp.data) {
    return [];
  }

  if (!!resp.data && !!resp.data.error) {
    console.log(resp.data.error);
    return [];
  }

  return resp.data;
}

export async function getGatewayList() {
  const opt = {
    url: `${Constant.GATEWAY_API}?limit=0`,
    method: "GET",
    headers: {
      Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
    },
  };
  let resp;

  try {
    resp = await axios(opt);
  } catch (err) {
    resp = err.response;
  }

  if (!resp.data) {
    console.log(resp.data);
    return [];
  }

  if (resp.data.error) {
    console.log(resp.data.error);
    return [];
  }

  return resp.data.data;
}

export function getStatusTags(status) {
  if (status === "S") return <Tag color="cyan">Sent</Tag>;
  else if (status === "RECVD") return <Tag color="blue">Received</Tag>;
  else if (status === "FG") return <Tag color="red">Fail Gateway</Tag>;
  else if (status === "FO") return <Tag color="red">Fail Operator</Tag>;
  else if (status === "A") return <Tag color="purple">Not-Received-A</Tag>;
  else if (status === "FM")
    return (
      <Tag
        color="#CCD5DB"
        style={{ color: "#526069", border: "1px solid #526069" }}
      >
        Not Received-M
      </Tag>
    );
  else if (status === "B")
    return (
      <Tag
        color="#CCD5DB"
        style={{ color: "#526069", border: "1px solid #526069" }}
      >
        Blacklist
      </Tag>
    );

  // INPR, E
  return <Tag>{status}</Tag>;
}



// WEBPACK FOOTER //
// ./src/containers/SlRawLogs/service.js